$(window).load(function(){
	 matchHeight();
    banner_carousel();
});
$(document).ready(function(){
	banner_carousel();
    matchHeight();
});

/*
	Variable Functions ==========================================================
*/
function banner_carousel(){
	jQuery('.banner-carousel').owlCarousel({
		loop:true,
		nav: true,
		navText: ["<i class='fa fa-long-arrow-left'></i>", "<i class='fa fa-long-arrow-right'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:1,

			},
			1000:{

				items:1,
			}
		}
	})
}

function matchHeight() {
  console.log("matchHeightisWorking");
  jQuery('.product-card__title').matchHeight();
  jQuery('.price').matchHeight();
  jQuery('.product-card__image-with-placeholder-wrapper').matchHeight();
  jQuery('.grid-view-item .product-card .product-card__title').matchHeight();
  jQuery('.match-me').matchHeight();
  jQuery('.match-details').matchHeight();
  jQuery('.price .price--listing .price--on-sale ').matchHeight();
  jQuery('.grid-view-item ').matchHeight();
  jQuery('.article__grid-image-wrapper ').matchHeight();
  jQuery('.article__grid-image ').matchHeight();
  jQuery('.article__title ').matchHeight();
}

